const createPageview = (path: string) => {
  for (let tagId of VisitWidget.settings.googleTagTrackingIds) {
    gtag("event", "page_view", {
      send_to: tagId,
      page_location: path.startsWith("/")
        ? window.location.origin + path
        : path,
    });
  }
};

const createEntityView = (
  eventName: "PlaceViewed" | "EventViewed" | "FeedPostViewed" | "TourViewed",
  url: string,
  id: string,
  name: string,
) => {
  for (let tag_id of VisitWidget.settings.googleTagTrackingIds) {
    gtag("event", eventName, {
      send_to: tag_id,
      page_location: url,
      name: name,
      id: id,
    });
  }
};

const createAnalyticsEvent = (
  action: string,
  options: Record<string, string | number>,
) => {
  for (let tag_id of Array.from(VisitWidget.settings.googleTagTrackingIds)) {
    gtag("event", action, {
      ...options,
      send_to: tag_id,
    });
  }
};

/**
 * When ad is visible on screen to user.
 */
const createAdImpression = (adId: string | number, adName: string) => {
  for (let tagId of VisitWidget.settings.googleTagTrackingIds) {
    gtag("event", "AdImpression", {
      send_to: tagId,
      id: adId,
      name: adName,
      label: createEntityLabel(adId, adName),
    });
  }
};

/**
 * When user clicks on ad.
 */
const createAdClick = (adId: string | number, adName: string) => {
  for (let tagId of VisitWidget.settings.googleTagTrackingIds) {
    gtag("event", "AdClickThrough", {
      send_to: tagId,
      id: adId,
      name: adName,
      label: createEntityLabel(adId, adName),
    });
  }
};

const createPlanAdd = (entityId: string | number, entityType: string) => {
  for (let tagId of VisitWidget.settings.googleTagTrackingIds) {
    gtag("event", "AddPlanItem", {
      send_to: tagId,
      type: entityType.toLowerCase(),
      id: entityId.toString(),
    });
  }
};

const createLikeClick = (
  entityId: string | number,
  entityType: string,
  entityName: string,
) => {
  createEntityEvent("LikeItem", entityId, entityType, entityName);
};

const createWebsiteClick = (
  entityId: string | number,
  entityType: string,
  entityName: string,
) => {
  createEntityEvent("WebsitePressed", entityId, entityType, entityName);
};

const createMapItClick = (
  entityId: string | number,
  entityType: string,
  entityName: string,
) => {
  createEntityEvent("MapItPressed", entityId, entityType, entityName);
};

const createPhoneClick = (
  entityId: string | number,
  entityType: string,
  entityName: string,
) => {
  createEntityEvent("PhoneCallPressed", entityId, entityType, entityName);
};

const createShareClick = (entityId, entityType, entityName) => {
  createEntityEvent("ShareItem", entityId, entityType, entityName);
};

const createSharePlanClick = (
  type: "email" | "twitter" | "facebook" | "sms",
) => {
  for (let tag_id of VisitWidget.settings.googleTagTrackingIds) {
    gtag("event", "SharePlan", {
      send_to: tag_id,
      type: type,
    });
  }
};

const createEntityLabel = (entityId, entityName) => {
  return `${entityId} | ${entityName}`;
};

const createEntityEvent = (eventName, entityId, entityType, entityName) => {
  for (let tag_id of VisitWidget.settings.googleTagTrackingIds) {
    gtag("event", eventName, {
      send_to: tag_id,
      id: entityId,
      type: entityType,
      name: entityName,
    });
  }
};

export {
  createSharePlanClick,
  createShareClick,
  createPhoneClick,
  createLikeClick,
  createMapItClick,
  createWebsiteClick,
  createAdClick,
  createAdImpression,
  createEntityView,
  createPlanAdd,
  createPageview,
  createAnalyticsEvent,
};
